import './styles.scss';
import React from 'react';
import Badge from 'antd/lib/badge';
import Button from 'antd/lib/button';
import { BgColorsOutlined, DownloadOutlined } from '@ant-design/icons';
import { t } from 'utils/i18n';
import { useSceneContext } from './scene/scene-context';
import { attentionCount } from './scene/scene-model';

interface Props {
    breadcrumb: JSX.Element;
    undo: JSX.Element;
    save: JSX.Element;
    drawingActions: JSX.Element | null;
    more: JSX.Element;
    onExportBlend?(): void;
}

export default function WorkspaceBar({
    breadcrumb, undo, save, drawingActions, more, onExportBlend,
}: Props): JSX.Element {
    const scene = useSceneContext();
    return (
        <div className='cvat-workspace-bar'>
            <div className='cvat-workspace-bar-left'>{breadcrumb}</div>
            <div className='cvat-workspace-bar-center'>{drawingActions}</div>
            <div className='cvat-workspace-bar-right'>
                {undo}
                {save}
                {more}
                {scene && (
                    <Badge
                        className='cvat-workspace-scene-badge'
                        count={scene.scene ? attentionCount(scene.scene) : 0}
                        size='small'
                        title={t('Items on a fallback or without a model')}
                    >
                        <Button
                            icon={<BgColorsOutlined />}
                            onClick={scene.toggle}
                            className={`cvat-workspace-scene-button ${scene.open ? 'cvat-button-active' : ''}`}
                            aria-pressed={scene.open}
                        >
                            {t('Scene')}
                        </Button>
                    </Badge>
                )}
                {onExportBlend && (
                    <Button type='primary' icon={<DownloadOutlined />} onClick={onExportBlend} className='cvat-workspace-export-blend'>
                        {t('Export .blend')}
                    </Button>
                )}
            </div>
        </div>
    );
}
